export enum UserType {
  PRODUCT_USER = 'PRODUCT_USER',
  GUEST_USER = 'GUEST_USER',
  API_USER = 'API_USER',
}
